import * as React from "react";
import { styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

const JourneyStepEl = styled.div`
  display: flex;
  flex-basis: 0;
  text-align: center;
  min-width: 212px;
  img {
    display: block;
    margin-bottom: 1rem;
  }
`;

const JourneyStepDesc = styled.div`
  margin: auto;
`;

const JourneyTitle = styled.h2`
  margin: 0;
  ${typeScale.xl};
  text-align: center;
`;

const JourneyInfo = styled.div`
  text-align: center;
`;

const JourneyChartEl = styled.div`
  justify-content: center;
  padding-top: 2rem;
  border-top: 1px solid ${(props) => props.theme.colours.bordersLight};
`;

const JourneySteps = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

const JourneyActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 3rem;
`;

export const JourneyChart: React.FC<React.ComponentProps<typeof JourneyChartEl>> & {
  Steps: typeof JourneySteps;
  Step: typeof JourneyStep;
  Title: typeof JourneyTitle;
  Info: typeof JourneyInfo;
  Actions: typeof JourneyActions;
} = ({ ...props }) => <JourneyChartEl {...props} />;

const JourneyStep: React.FC<React.PropsWithChildren<{ imgSrc: string }>> = ({ imgSrc, children }) => {
  return (
    <JourneyStepEl>
      <div>
        <img height={158} src={imgSrc} />
        <JourneyStepDesc>{children}</JourneyStepDesc>
      </div>
    </JourneyStepEl>
  );
};

JourneyChart.Steps = JourneySteps;
JourneyChart.Step = JourneyStep;
JourneyChart.Info = JourneyInfo;
JourneyChart.Title = JourneyTitle;
JourneyChart.Actions = JourneyActions;
